import { useContext } from 'react';
import zhCN from '../../locales/zh-CN.js';
import enUS from '../../locales/en-US.js';
import deDE from '../../locales/de-DE.js';
import esES from '../../locales/es-ES.js';
import frFR from '../../locales/fr-FR.js';
import itIT from '../../locales/it-IT.js';
import ptPT from '../../locales/pt-PT.js';
import trTR from '../../locales/tr-TR.js';
import jaJP from '../../locales/ja-JP.js';
import ConfigContext from '../../TiConfigProvider/context/index.js';

function useLanguage(ns) {
  var locale = useContext(ConfigContext).locale;
  switch (locale) {
    case 'zh-CN':
      return zhCN[ns];
    case 'en-US':
      return enUS[ns];
    case 'de-DE':
      return deDE[ns];
    case 'es-ES':
      return esES[ns];
    case 'fr-FR':
      return frFR[ns];
    case 'it-IT':
      return itIT[ns];
    case 'pt-PT':
      return ptPT[ns];
    case 'tr-TR':
      return trTR[ns];
    case 'ja-JP':
      return jaJP[ns];
    default:
      return zhCN[ns];
  }
}

export { useLanguage as default };
